import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "react-bootstrap";

import Overlay from "./Overlay";

// css
import styles from "../Sidebar.module.scss";

// actions
import actions from "../../../store/actions";

function getRandomColor() {
  let letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

const Sidebar = () => {
  const dispatch = useDispatch();

  const { overlaySettings } = useSelector((state) => state.gannWheel);

  const handleOverlayChange = (index, name) => (evt) => {
    dispatch(
      actions.updateByName({
        category: "overlaySettings",
        name: "overlays",
        value: [
          ...overlaySettings.overlays.slice(0, index),
          { ...overlaySettings.overlays[index], [name]: evt.target.value },
          ...overlaySettings.overlays.slice(index + 1),
        ],
      })
    );
  };

  const addNewOverlay = () => {
    dispatch(
      actions.updateByName({
        category: "overlaySettings",
        name: "overlays",
        value: [
          ...overlaySettings.overlays,
          {
            overlay: "degrees",
            direction: "clockwise",
            startFrom: "selection",
            color: getRandomColor(),
          },
        ],
      })
    );
  };

  const removeOverlay = (idx) => () => {
    dispatch(
      actions.updateByName({
        category: "overlaySettings",
        name: "overlays",
        value: [
          ...overlaySettings.overlays.slice(0, idx),
          ...overlaySettings.overlays.slice(idx + 1),
        ],
      })
    );
  };

  return (
    <div className={`${styles.CstmDropdown} CstmDropdown h-100`}>
      <div className="top text-end">
        <Button
          className="d-inline-flex bg-transparent border-0 p-0"
          onClick={addNewOverlay}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M15 7H9V1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0C7.73478 0 7.48043 0.105357 7.29289 0.292893C7.10536 0.48043 7 0.734784 7 1V7H1C0.734784 7 0.48043 7.10536 0.292893 7.29289C0.105357 7.48043 0 7.73478 0 8C0 8.26522 0.105357 8.51957 0.292893 8.70711C0.48043 8.89464 0.734784 9 1 9H7V15C7 15.2652 7.10536 15.5196 7.29289 15.7071C7.48043 15.8946 7.73478 16 8 16C8.26522 16 8.51957 15.8946 8.70711 15.7071C8.89464 15.5196 9 15.2652 9 15V9H15C15.2652 9 15.5196 8.89464 15.7071 8.70711C15.8946 8.51957 16 8.26522 16 8C16 7.73478 15.8946 7.48043 15.7071 7.29289C15.5196 7.10536 15.2652 7 15 7Z"
              fill="black"
            />
          </svg>
        </Button>
      </div>

      <div className="bottom h-100">
        <div className="table-responsive h-100">
          <table className="table">
            <thead>
              <tr>
                <th className="px-1 py-1 bg-transparent border-0 ws-nowrap"></th>
                <th className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                  Overlay
                </th>
                <th className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                  Value
                </th>
                <th className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                  Direction
                </th>
                <th className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                  Start From
                </th>
                <th className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                  Colour
                </th>
                <th className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                  Repeat
                </th>
              </tr>
            </thead>

            <tbody>
              {overlaySettings.overlays.map((overlay, idx) => (
                <Overlay
                  key={`overlay-${idx}`}
                  overlay={overlay}
                  idx={idx}
                  removeOverlay={removeOverlay}
                  handleOverlayChange={handleOverlayChange}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
